(function (){
    'use strict';

    angular
        .module('services')
        .service('AdminEdufindmeService', AdminEdufindmeService);

    AdminEdufindmeService.$inject = ['$http', 'API_BASE'];

    function AdminEdufindmeService ($http, API_BASE) {
        var service = this;

        service.saveAdmin                     = saveAdmin;
        service.administrators                = administrators;
        service.deleteAdmin                   = deleteAdmin;
        service.userUpdate                    = userUpdate;


        function saveAdmin (query) {
            //if(page == null)
                return $http.post(API_BASE + '/edufindme/admin/save', query);
            //else
                //return $http.get(API_BASE + '/edufindme/filter'+page, fields);
        }

        function administrators (query) {
            return $http.get(API_BASE + '/edufindme/administrators/list', {'params':query});
        }

        function deleteAdmin (type, id) {
            return $http.delete(API_BASE + '/edufindme/administrators/' + type + '/' + id + '/delete');
        }

        function userUpdate (id, data) {
            return $http.put(API_BASE + `/edufindme/user/${id}`, data);
        }
    }
})();